import React from 'react';
import cn from 'classnames';

import {Navigation} from '../Navigation/Navigation';

import Logo from 'assets/image/header/logo-2.png';
import CloseIcon from 'assets/image/mobile-nav/close.svg';

import '../styles.scss';

interface IMobileDrawerProps {
  isOpen: boolean;
  roles: string[];
  onClose: () => void;
}

export const MobileDrawer = ({isOpen, roles, onClose}: IMobileDrawerProps): JSX.Element => {
  return (
    <>
      <button
        type="button"
        className={cn('mobile-drawer__backdrop', {'mobile-drawer__backdrop--open': isOpen})}
        onClick={onClose}
        aria-label="Close menu"
        tabIndex={isOpen ? 0 : -1}
      />
      <div
        className={cn('mobile-drawer', {'mobile-drawer--open': isOpen})}
        role="dialog"
        aria-modal="true"
        aria-hidden={!isOpen}
      >
        <div className="mobile-drawer__header">
          <img className="mobile-drawer__logo" src={Logo} alt="Logo"/>
          <button
            type="button"
            className="mobile-drawer__close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <img src={CloseIcon} alt="" role="presentation"/>
          </button>
        </div>
        <div className="mobile-drawer__divider"/>
        <Navigation className="nav__drawer" onOpenMenu={onClose} roles={roles}/>
      </div>
    </>
  );
};
